var _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _g4, _path7, _path8, _g5, _path9, _g6, _path10, _path11, _g7, _path12, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlmAiAct1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_360)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_360",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 0,
    width: 6,
    height: 5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.37 0H17.58V4.77H22.37V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.34 4.74001C22.34 3.42001 21.8 2.23001 20.94 1.37001C19.7 0.140015 17.6 1.03001 17.6 2.77001C17.6 3.86001 18.48 4.73001 19.56 4.73001H22.34V4.74001Z",
    fill: "url(#paint0_linear_21_360)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.34 6.19H16.13C13.71 6.19 11.75 8.15 11.75 10.57H17.96C20.38 10.57 22.34 8.61 22.34 6.19Z",
    fill: "url(#paint1_linear_21_360)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_21_360",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 6,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.51 0H11.72V4.77H16.51V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_21_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.49 0H11.75V4.74C14.36 4.74 16.49 2.62 16.49 0Z",
    fill: "url(#paint2_linear_21_360)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.039978 16.19H6.24998C8.66998 16.19 10.63 14.23 10.63 11.81H4.41998C1.99998 11.8 0.039978 13.76 0.039978 16.19Z",
    fill: "url(#paint3_linear_21_360)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_21_360",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 17,
    width: 5,
    height: 6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81002 17.62H0.0200195V22.37H4.81002V17.62Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_21_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0400391 17.63C0.0400391 18.95 0.580039 20.14 1.44004 21C2.68004 22.23 4.78004 21.34 4.78004 19.6C4.78004 18.51 3.90004 17.64 2.82004 17.64H0.0400391V17.63Z",
    fill: "url(#paint4_linear_21_360)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_21_360",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 17,
    width: 6,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.64 17.62H5.84998V22.37H10.64V17.62Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_21_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.88995 22.37H10.63V17.63C8.00995 17.63 5.88995 19.75 5.88995 22.37Z",
    fill: "url(#paint5_linear_21_360)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.57 10.63V4.42001C10.57 2.00001 8.61 0.0400085 6.19 0.0400085V6.25001C6.19 8.67001 8.15 10.63 10.57 10.63Z",
    fill: "url(#paint6_linear_21_360)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_21_360",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 0.019989H0V4.80999H4.77V0.019989Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_21_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73999 0.039978C3.42999 0.039978 2.23999 0.569978 1.37999 1.43998C0.149994 2.67998 1.03999 4.77998 2.77999 4.77998C3.86999 4.77998 4.73999 3.89998 4.73999 2.81998V0.039978Z",
    fill: "url(#paint7_linear_21_360)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_21_360",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 5,
    height: 6
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 5.85001H0V10.64H4.77V5.85001Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_21_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.74 10.63C4.74 8.01002 2.62 5.89001 0 5.89001V10.63H4.74Z",
    fill: "url(#paint8_linear_21_360)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 11.74V17.95C11.8 20.37 13.76 22.33 16.18 22.33V16.12C16.18 13.7 14.22 11.74 11.8 11.74Z",
    fill: "url(#paint9_linear_21_360)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_21_360",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 6,
    height: 6
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.37 17.58H17.62V22.37H22.37V17.58Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_21_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.63 22.34C18.95 22.34 20.14 21.8 21 20.94C22.23 19.7 21.34 17.6 19.6 17.6C18.51 17.6 17.64 18.48 17.64 19.56V22.34H17.63Z",
    fill: "url(#paint10_linear_21_360)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_21_360",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 11,
    width: 6,
    height: 6
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.37 11.72H17.62V16.51H22.37V11.72Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_21_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.63 11.74C17.63 14.36 19.75 16.48 22.37 16.48V11.74H17.63Z",
    fill: "url(#paint11_linear_21_360)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_360",
    x1: 17.59,
    y1: 2.77001,
    x2: 22.34,
    y2: 2.77001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_360",
    x1: 11.74,
    y1: 8.38,
    x2: 1,
    y2: 8.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_360",
    x1: 11.74,
    y1: 2.37,
    x2: 16.49,
    y2: 2.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21_360",
    x1: 0.039978,
    y1: 13.99,
    x2: 10.63,
    y2: 13.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21_360",
    x1: 0.0400391,
    y1: 19.6,
    x2: 4.78004,
    y2: 19.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21_360",
    x1: 5.88995,
    y1: 20,
    x2: 10.63,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_21_360",
    x1: 6.19,
    y1: 5.33001,
    x2: 10.57,
    y2: 5.33001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_21_360",
    x1: 0.809994,
    y1: 2.40998,
    x2: 4.73999,
    y2: 2.40998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_21_360",
    x1: 0,
    y1: 8.26001,
    x2: 4.74,
    y2: 8.26001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_21_360",
    x1: 11.8,
    y1: 17.04,
    x2: 16.19,
    y2: 17.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_21_360",
    x1: 17.63,
    y1: 19.97,
    x2: 21.57,
    y2: 19.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_21_360",
    x1: 17.63,
    y1: 14.11,
    x2: 22.37,
    y2: 14.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.37,
    height: 22.37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlmAiAct1);
export default __webpack_public_path__ + "static/media/BlmAIAct_1.0bedf1c904722af9b748c0ce642a38ec.svg";
export { ForwardRef as ReactComponent };